/*
 * @Description: 工具类中的通用函数
 * @Author: fiveonelei
 * @Date: 2022-01-19 16:53:46
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/common.ts
 */

import { IHashMap } from '@/types/data';

// 生成随机字符串
export const randomString = (num = 32) => {
  const pool = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const len = pool.length;
  let res = '';
  for (let i = 0; i < num; i += 1) res += pool.charAt(Math.floor(Math.random() * len));
  return res;
};

// 缓存最近一次点击上报的信息
let latestClickReportInfo: IHashMap | null = null;
export function setLatestClickReportInfo(info: IHashMap) {
  latestClickReportInfo = info;
}

export function getLatestClickReportInfo(clearAfter = true) {
  const info = latestClickReportInfo;
  if (clearAfter) {
    latestClickReportInfo = null;
  }
  return info;
}

/**
 * 为 promise 操作提供重试机制
 * @param {*} promiseFn 要执行的 promise 操作
 * @param {*} maxRetryCnt 最大可重试次数
 * @param {*} curRetryCnt 当前第几次重试
 */
export async function retryPromiseFn<T>(promiseFn: () => Promise<T>, maxRetryCnt = 3, curRetryCnt = 0): Promise<T> {
  let retryCnt = curRetryCnt;
  let isRejected = false;
  let result = null;

  try {
    result = await promiseFn();
  } catch (err) {
    isRejected = true;
    retryCnt += 1;

    if (retryCnt >= maxRetryCnt) {
      throw err;
    }
  }

  if (!isRejected) {
    return result as T;
  }
  return retryPromiseFn(promiseFn, maxRetryCnt, retryCnt);
};
